<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row mb-0">
        <div class="col-12 col-sm-6 col-lg-3 form-group align-self-center">
            <select class="custom-select col-md-12" (change)="selection();teacherStatus($event)" [(ngModel)]="teacherCorrectionStatus">
                <option value="0">All</option>
                <option value="1">Correction Pending</option>
                <option value="2">Correction Completed</option>
                <option value="3">Score Released</option>
                <option value="4">Overdue</option>
            </select>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 form-group align-self-center">
            <select class="custom-select col-md-12" id="content" (change)="selection();contentselect($event)" [(ngModel)]="contentType">
                <option value="2">Assignment</option>
                <option value="3">Assessment</option>
            </select>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 form-group align-self-center">
            <ng-select [items]="classesDetails"
                       bindLabel="class_name"
                       bindValue="class_id"
                       [(ngModel)]="selectedClass"
                       placeholder="Select Class"
                       typeToSearchText=""
                       (change)="selection();studentContentDetails()">
                <ng-template ng-option-tmp let-item="item">
                    <div [title]="item.class_name">{{item.class_name}}</div>
                </ng-template>
            </ng-select>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
            <div class="btn-popup pull-right mb-0">
                <div class="input-group">
                    <input type="text" class="form-control" style="height:40px" size="50" placeholder="Search Student" [(ngModel)]="searchStudent" (input)="updateFilter(searchStudent)">
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="submit"><i class="fa fa-search" aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <ng-select [items]="batchData"
                       bindLabel="batch_name"
                       bindValue="batch_id"
                       [(ngModel)]="selectClassRoom"
                       placeholder="Select Content Folder"
                       typeToSearchText=""
                       (change)="selection();studentContentDetails()">
            </ng-select>
        </div>
        <div class="col-md-3" *ngIf="auth.getRoleId() != '4'">
            <ng-select [items]="teacherListData"
                       bindLabel="teacher_name"
                       bindValue="teacher_id"
                       [(ngModel)]="selectTeacher"
                       placeholder="Select Teacher"
                       typeToSearchText=""
                       (change)="selection();studentContentDetails()"
            >
            </ng-select>
        </div>
        <div *ngIf="teacherCorrectionStatus != '4' && teacherCorrectionStatus != '0'" class="col-md-3 d-flex">
            <input #dp="angular-mydatepicker" (click)="dp.toggleCalendar()"
                   (dateChanged)="onDateChanged($event);selection();studentContentDetails()" [options]="myDpOptions" [placeholder]="teacherCorrectionStatus == '3' ? 'Search Release Date' : 'Search Submitted Date'" [value]="selectDate" angular-mydatepicker
                   autocomplete="off" class="form-control" name="dp">
            <div class="input-group-append">
                <button (click)="dp.toggleCalendar()" class="btn btn-primary" type="button">
                    <i class="fa fa-calendar-o"></i></button>
            </div>
        </div>
        <div class="col-md-3">
            <div class="btn-popup pull-right mb-0">
                <div class="input-group">
                    <input (input)="updateFilter(searchContent)" [(ngModel)]="searchContent" class="form-control" placeholder="Search {{contentType == '2' ? 'Assignment' : 'Assessment'}}" size="50" style="height:40px" type="text">
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="submit"><i aria-hidden="true" class="fa fa-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <button (click)="notifyParent(choosedData, 1)" *ngIf="teacherCorrectionStatus == '4'" class="btn btn-sm btn-primary pull-right">Notify All</button>
        </div>
    </div>
    <div class="row d-flex justify-content-end">
        <div class="col-md-3">
            <button (click)="releaseAll()" *ngIf="teacherCorrectionStatus == '2'" class="btn btn-sm btn-primary pull-right mt-3">Release Score For All</button>
        </div>
    </div>
    <div *ngIf="choosedData =='' && functionCalled" class="row d-flex justify-content-center mt-5">
        <div class="col-4">
            <button class="nodataList">No Data Available!</button>
        </div>
    </div>
    <div *ngIf="!functionCalled" id="custom-pdf-loader" style="height: 60vh;">
        <img alt="" src="assets/images/pre-loader/loader-01.svg">
    </div>
    <section class="row list-card mt-3">
        <div class="scrollPanel1" style="height: 71vh !important;">
            <div *ngIf="choosedData != ''"
                 class="search-results col-md-12"
                 infiniteScroll
                 [infiniteScrollDistance]="2"
                 [infiniteScrollThrottle]="50"
                 [infiniteScrollContainer]="selector"
                 [fromRoot]="true"
                 (scrolled)="onScrollDown($event)">
                <div class="col-md-12">
                    <div class="card class-hover class-card" *ngFor="let list of choosedData; let i = index">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-1 d-flex justify-content-center align-items-center">
                                    <figure *ngIf="this.list.student_profile == ''">
                                        <img alt="" class="rounded-circle img-50 border" src="assets/images/digital-product/student.png">
                                    </figure>
                                    <figure *ngIf="this.list.student_profile != ''">
                                        <img class="rounded-circle img-50" [src]="sanitizer.bypassSecurityTrustResourceUrl(webhost + '/' + list.student_profile)" alt="">
                                    </figure>
                                </div>
                                <div class="col-7">
                                    <h4><small *ngIf="list.status == '3'" class="badge badge-primary">Score Released</small>
                                        <small *ngIf="list.status == '4' || list.status == '6'" class="badge badge-info">Correction Pending</small>
                                        <small *ngIf="list.status == '5'" class="badge badge-success">Correction Completed</small>
                                        <small *ngIf="list.status == '1'" class="badge badge-secondary">Yet To Start</small>
                                        <small *ngIf="list.status == '2'" class="badge badge-warning">In-Progress</small> &nbsp;
                                        <span (click)="getStudentFullDetail(list)" class="t-period font-weight-bold cursor name-hover">{{list.student_name}}</span>
                                    </h4>
                                    <p><span class="font-weight-bold">Class Name: </span> <span class="t-name capital font-weight-bold">{{list.class_name}}</span>&nbsp;
                                        &nbsp; <span class="font-weight-bold">Content Name: </span> <span class="t-name font-weight-bold">{{list.content_name}}</span>
                                        <br/><span *ngIf="list.status > 2"><span class="font-weight-bold">Submitted Date: </span> <span class="t-name font-weight-bold">{{list.answer_completed_date | customDateFormat}}</span></span>&nbsp;
                                        <span *ngIf="list.status == '3'"><span class="font-weight-bold">Score Released Date: </span> <span class="t-name font-weight-bold">{{list.score_release_date | customDateFormat}}</span></span></p>
                                </div>
                                <div class="col-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="pull-right total-score mr-2" *ngIf="list.status == '3'">Total Score: <span class="t-name">{{list.total_score}}</span></span>
<!--                                            <small class="pull-right total-score" style="visibility: hidden" *ngIf="list.status != '3' && list.status != '2' && list.status != '1'">Total Score: <span class="t-name">{{list.total_score}}</span></small>-->
                                            <span class="pull-right total-score mr-2"
                                                   *ngIf="list.status == '1' || list.status == '2' && list.status != '3'">Overdue For:
                                                <span class="over-due1" *ngIf="list.overDue != '1'">{{list.overDue}} (days)</span>
                                                <span class="over-due1" *ngIf="list.overDue == '1'">{{list.overDue}} (day)</span>
                                            </span>
                                            <span class="pull-right total-score mr-2" *ngIf="list.status == '3'">Obtained Score: <span class="t-name">{{list.obtained_score}}</span></span>
                                            <span class="pull-right total-score mr-2"
                                                   *ngIf="list.status != '3'">End Date:
                                                <span *ngIf="list.end_date != '0000-00-00'" class="over-due1">{{list.end_date | customDateFormat}}</span>
<!--                                                <span class="over-due1" *ngIf="list.end_date == '0000-00-00'" style="visibility: hidden">{{list.end_date |date:'MM-dd-yyyy'}}</span>-->
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row d-flex align-self-end mt-2">
                                        <div class="col-md-12 d-flex justify-content-end">
                                            <button (click)="openNotes(list)" class="btn-outline-primary btn-sm-view mt-2 mr-2" title="Add Notes"><i aria-hidden="true" class="fa fa-newspaper-o"></i></button>
                                            <button (click)="notifyParent(list, 2)" *ngIf="list.status == '1' || list.status == '2'" class="btn-sm-i btn-outline-primary pull-right mt-2" type="button">Notifiy Parent</button>
                                            <button (click)="releaseScore(list)" *ngIf="list.status == '5'" class="btn-sm-i btn-outline-primary pull-right mt-2" type="button">Release Score</button>
                                            <button *ngIf="list.status == '1'" [disabled]="list.status == 1" class="btn-sm-i btn-outline-primary pull-right ml-2 mt-2" type="button">Enter</button>
                                            <button *ngIf="list.status != '1'" class="btn-sm-i btn-primary pull-right ml-2 mt-2" (click)="enterAction(list)" type="button">Enter</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #contentnow let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title col-12 text-center"><b>Notify Parent</b></h4>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <h5 *ngIf="notifyType == 1" class="text-center">Are You Sure want to notify all parents?</h5>
            <h5 *ngIf="notifyType == 2" class="text-center">Are You Sure want to notify {{studentname[0].student_name}} parents?</h5>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="this.notifyType == 1" type="button" class="btn btn-primary" (click)="confirmStudentNotify(1)">Confirm</button>
        <button *ngIf="this.notifyType == 2" type="button" class="btn btn-primary" (click)="confirmStudentNotify(2)">Confirm</button>
        <button type="button" class="btn btn-outline-primary" (click)="close()">Cancel</button>
    </div>
</ng-template>


<ng-template #writeNoteOpen let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-center">Add Notes</h4>
        <i (click)="close()" class="fa fa-close cursor" ></i>
    </div>
    <div class="modal-body">
        <div class="row d-flex justify-content-center">
            <div *ngFor="let list of showNotes; let i = index" class="col-10 mt-2">
                <div class="row border border-secondary rounded">
                    <div class="col-8 d-flex" style="word-wrap: break-word;">
                        <i *ngIf="list.notes_type == '2'" class="fa fa-envelope-square align-self-center mr-2 color-primary"></i>
                        <i *ngIf="list.notes_type == '1'" class="fa fa-bookmark align-self-center mr-2 color-secondary"></i>
                        <!-- <p [innerText]="list.notes" class="mb-0"></p> -->
                        <span [innerHTML]="list.notes" class="mb-0 mt-3"></span>
                    </div>
                    <div class="col-3 px-0 d-flex justify-content-end align-self-center">
                        <small class="mb-0">{{list.created_date | customDateFormat}}</small>
                    </div>
                    <div class="col-1 align-self-center">
                        <i (click)="deleteNotes(list)" aria-hidden="true" class="fa fa-close fa-1x text-danger" style="cursor:pointer"></i>
                    </div>
                </div>
            </div>
            <div class="col-11 mt-2">
                <!-- <textarea class="form-control" id="addNotes" placeholder="Enter Notes" style="width: 100%; height: 100px; padding: 4px"></textarea> -->
            <app-tiny-mice  (emitEditorValue)="getEditorValue($event)"
                [editorPatchValue]="false"
                [height]="300"
                [id]="'addNotes'"
                [showDropBtn]="false"
                [showInputBtn]="false">
            </app-tiny-mice>
            </div>
            <div class="col-11 text-right mt-2">
                <button (click)="addNotes('2')" class="btn btn-outline-primary mr-2" type="button">Send as Email</button>
                <button (click)="addNotes('1')" class="btn btn-primary" type="button">Add</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #viewoveralldetails let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title color-primary" id="modal-basic-title">{{studentName}} Overall details</h4>
        <i (click)="closeOverAll()" aria-hidden="true"
           class="fa fa-close fa-lg mt-1" style="color:#7F3486; cursor: pointer; float: right;"></i>
    </div>
    <div class="modal-body">
        <app-overalldetails
                [studentdata]="viewdetail"
        >
        </app-overalldetails>
    </div>
<!--    <div class="modal-footer">-->
<!--        <button (click)="close()" class="btn cancel" type="button">Cancel</button>-->
<!--        <button class="btn btn-primary" type="button">Edit</button>-->
<!--    </div>-->
</ng-template>

<!-- Container-fluid Ends-->

